import { IPhongNamHocRequest } from "../models/request/danh-muc/IPhongNamHocRequest";
import { noitru_phong_namhoc } from "../models/response/category/noitru_phong_namhoc";
import { apiClient } from "./apiClient";
import { BaseCRUDApi } from "./baseCRUDApi";

export const API_PHONG_NAM_HOC_PATH = "phong-nam-hoc"
class PhongNamHocApi extends BaseCRUDApi<noitru_phong_namhoc> {
    constructor({ path }: { path: string; }) {
        super(path);
    }
    Select() {
        return apiClient.get(`${this._path}/select`);
    }
}
export const phongNamhocApi = new PhongNamHocApi({ path: API_PHONG_NAM_HOC_PATH });

